export default __webpack_public_path__ + "static/media/gallery_10.a2d9e4a2.jpg";